import NotificationTemplate from '../../html/components/notification.html'
import NotificationListTemplate from '../../html/components/notification-list.html'
import NotificationOverlayTemplate from '../../html/components/notification-overlay.html'

import Component from '../shared/component'
import Relation, {HasMany, MemberOf} from '../shared/mixins/relation'

const notificationList = Relation()

export const Notification = Component('v-notification', {
  mixins: [
    MemberOf(notificationList, 'list')
  ],
  template: NotificationTemplate,
  props: {
    variant: {
      type: String,
      default: 'information',
      validator (value) {
        switch (value) {
          case 'success':
          case 'warning':
          case 'danger':
          case 'information':
            return true
          default:
            return false
        }
      }
    },
    dismissible: {
      type: Boolean,
      default: false
    },
    labelClose: {
      type: String
    }
  },
  data () {
    return {
      closed: false
    }
  },
  computed: {
    variantClass () {
      return `is-${this.variant}`
    }
  },
  watch: {
    closed (closed) {
      if (closed) {
        this.$emit('close', this)
      }
    }
  },
  methods: {
    close () {
      this.closed = true
    }
  }
})

export const NotificationList = Component('v-notification-list', {
  mixins: [
    HasMany(notificationList, 'notifications')
  ],
  template: NotificationListTemplate,
  props: {
    limit: {
      type: [
        String,
        Number
      ],
      default: null
    }
  },
  watch: {
    notifications () {
      const {limit, notifications} = this

      if (limit === null) {
        return
      }

      const open = notifications.filter(n => !n.closed)

      if (open.length > limit) {
        for (let i = 0, n = open.length - limit; i < n; i++) {
          open[i].close()
        }
      }
    }
  }
})

export const NotificationOverlay = Component('v-notification-overlay', {
  template: NotificationOverlayTemplate
})
